// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
Case Usage Example:
h1 { @include font-roboto(400); }
**/
h1 {
  font-size: 2rem;
  margin: 5px 0;
}
@media (max-width: 768px) {
  h1 {
    font-size: 1.5rem;
  }
}

h2 {
  font-size: 1.8rem;
  margin: 5px 0;
}
@media (max-width: 768px) {
  h2 {
    font-size: 1.2rem;
  }
}

:root {
  overflow-x: hidden;
  height: 100%;
}

* {
  font-family: "Roboto", sans-serif;
  font-weight: 200;
  box-sizing: border-box;
  outline: none;
}

*:focus {
  outline: none;
}

html,
body {
  margin: 0;
  padding: 0;
}

body {
  min-height: 100%;
  font-size: 1.3rem;
}
@media (max-width: 768px) {
  body {
    font-size: 1.2rem;
  }
}
@media (max-width: 576px) {
  body {
    font-size: 1.1rem;
  }
}

h1, h2, h3, h4, h5, h6 {
  font-family: "Roboto", sans-serif;
  font-weight: 400;
}

.container {
  width: 100%;
  max-width: 1200px;
  padding: 15px;
  box-sizing: border-box;
  margin: 0 auto;
}

hr.style-one {
  width: 90%;
  border: 0;
  height: 1px;
  background: #333;
  background-image: linear-gradient(to right, #ccc, #333, #ccc);
}

hr.style-two {
  width: 90%;
  border: 0;
  height: 1px;
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0));
}

hr.style-three {
  width: 90%;
  border: 0;
  border-bottom: 1px dashed #ccc;
  background: #999;
}

.error-color {
  color: #aa004f;
}

/**  **/
.profile-wrapper,
.shifts-dashboard,
.profile-components,
.profile-page-content--show-tab { /* Safari, Chrome and Opera > 12.1 */ /* Firefox < 16 */ /* Internet Explorer */ /* Opera < 12.1 */
  animation: fadein 1s;
  min-height: calc(100vh - 230px);
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Firefox < 16 */
/* Safari, Chrome and Opera > 12.1 */
/* Internet Explorer */
/* Opera < 12.1 */
.profile-icon-dropdown-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-shadow: rgba(50, 50, 105, 0.15) 0 2px 5px 0, rgba(0, 0, 0, 0.05) 0 1px 1px 0;
  background-color: #ffffff;
  font-family: "Roboto", sans-serif;
  font-weight: 100;
  width: 150px;
}
.profile-icon-dropdown-wrapper:after {
  content: " ";
  position: absolute;
  right: 30px;
  top: -15px;
  border-top: none;
  border-right: 15px solid transparent;
  border-left: 15px solid transparent;
  border-bottom: 15px solid white;
}
.profile-icon-dropdown-wrapper .profile-dropdown-items {
  cursor: pointer;
  text-decoration: none;
  color: #000000;
  margin: 5px 0;
  padding: 3px 10px;
  width: 100%;
  display: flex;
  align-self: flex-start;
}
.profile-icon-dropdown-wrapper .profile-dropdown-items:hover {
  background-color: #aa004f;
  color: white;
}
.profile-icon-dropdown-wrapper .profile-icon-language {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 5px;
  padding: 2px 0;
}
.profile-icon-dropdown-wrapper .profile-icon-language .profile-icon-language-fr {
  cursor: pointer;
  padding: 0 5px;
  width: 100%;
  display: flex;
  align-self: flex-start;
}
.profile-icon-dropdown-wrapper .profile-icon-language .profile-icon-language-fr:hover {
  background-color: #aa004f;
}
.profile-icon-dropdown-wrapper .profile-icon-language .profile-icon-language-en {
  cursor: pointer;
  padding: 0 5px;
}
.profile-icon-dropdown-wrapper .profile-icon-language .profile-icon-language-en:hover {
  background-color: #aa004f;
}`, "",{"version":3,"sources":["webpack://./src/css/fonts.scss","webpack://./src/components/ProfileIconDropDown/styles.scss","webpack://./src/css/general.scss","webpack://./src/css/colors.scss"],"names":[],"mappings":"AAMA;;;EAAA;AASA;EACE,eAAA;EACA,aAAA;ACTF;ADUE;EAHF;IAII,iBAAA;ECPF;AACF;;ADSA;EACE,iBAAA;EACA,aAAA;ACNF;ADOE;EAHF;IAII,iBAAA;ECJF;AACF;;ACpBA;EACE,kBAAA;EACA,YAAA;ADuBF;;ACrBA;EFJE,iCAAA;EACA,gBEIqB;EACrB,sBAAA;EACA,aAAA;ADyBF;;ACvBA;EACE,aAAA;AD0BF;;ACxBA;;EAEE,SAAA;EACA,UAAA;AD2BF;;ACzBA;EACE,gBAAA;EACA,iBFTO;ACqCT;AC1BE;EAJF;IAKI,iBFbK;EC0CP;AACF;AC5BE;EAPF;IAQI,iBFjBK;ECgDP;AACF;;AC5BA;EF7BE,iCAAA;EACA,gBE6BqB;ADgCvB;;AC7BA;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;ADgCF;;AC7BA;EACE,UAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,6DAAA;ADgCF;;AC9BA;EACE,UAAA;EACA,SAAA;EACA,WAAA;EACA,oGAAA;ADiCF;;AC/BA;EACE,UAAA;EACA,SAAA;EACA,8BAAA;EACA,gBAAA;ADkCF;;AChCA;EACE,cC3DO;AF8FT;;AC9BA,OAAA;AACA;;;kCAIE,oCAAA,EACA,iBAAA,EACA,sBAAA,EACA,iBAAA;EACA,oBAAA;EACA,+BAAA;ADiCF;;AC9BA;EACE;IAAO,UAAA;EDkCP;ECjCA;IAAO,UAAA;EDoCP;AACF;AClCA,iBAAA;AAMA,oCAAA;AAMA,sBAAA;AAMA,iBAAA;ADrGA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gFAAA;EACA,yBAAA;EDNA,iCAAA;EACA,gBCMqB;EACrB,YAAA;AA4JF;AA3JE;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,oCAAA;EACA,mCAAA;EACA,+BAAA;AA6JJ;AA1JE;EACE,eAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AA4JJ;AA1JI;EACE,yBE7BG;EF8BH,YAAA;AA4JN;AAzJE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;AA2JJ;AAzJI;EACE,eAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AA2JN;AA1JM;EACE,yBE/CC;AF2MT;AAvJI;EACE,eAAA;EACA,cAAA;AAyJN;AAxJM;EACE,yBExDC;AFkNT","sourcesContent":["@import \"./breakpoints\";\n@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700;900&display=swap');\n@mixin font-roboto($weight) {\n  font-family: 'Roboto', sans-serif;\n  font-weight: $weight;\n}\n/**\nCase Usage Example:\nh1 { @include font-roboto(400); }\n**/\n\n$font-sm:1.1rem;\n$font-md:1.2rem;\n$font-lg:1.3rem;\n\nh1 {\n  font-size: 2rem;\n  margin: 5px 0;\n  @media (max-width: $md) {\n    font-size: 1.5rem;\n  }\n}\nh2 {\n  font-size: 1.8rem;\n  margin: 5px 0;\n  @media (max-width: $md) {\n    font-size: 1.2rem;\n  }\n}\n","@import \"../../css/breakpoints.scss\";\n@import \"../../css/colors.scss\";\n@import \"../../css/general.scss\";\n\n.profile-icon-dropdown-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  box-shadow: rgba(50, 50, 105, 0.15) 0 2px 5px 0, rgba(0, 0, 0, 0.05) 0 1px 1px 0;\n  background-color: #ffffff;\n  @include font-roboto(100);\n  width: 150px;\n  &:after {\n    content: \" \";\n    position: absolute;\n    right: 30px;\n    top: -15px;\n    border-top: none;\n    border-right: 15px solid transparent;\n    border-left: 15px solid transparent;\n    border-bottom: 15px solid white;\n  }\n\n  .profile-dropdown-items {\n    cursor: pointer;\n    text-decoration: none;\n    color: #000000;\n    margin: 5px 0;\n    padding: 3px 10px;\n    width: 100%;\n    display: flex;\n    align-self: flex-start;\n\n    &:hover {\n      background-color: $color6;\n      color: white;\n    }\n  }\n  .profile-icon-language {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    margin: 5px;\n    padding: 2px 0;\n\n    .profile-icon-language-fr {\n      cursor: pointer;\n      padding: 0 5px;\n      width: 100%;\n      display: flex;\n      align-self: flex-start;\n      &:hover {\n        background-color: $color6;\n      }\n    }\n    .profile-icon-language-divider {\n    }\n    .profile-icon-language-en {\n      cursor: pointer;\n      padding: 0 5px;\n      &:hover {\n        background-color: $color6;\n      }\n    }\n  }\n}\n","@import \"fonts\";\n@import \"breakpoints\";\n@import \"colors\";\n:root {\n  overflow-x: hidden;\n  height: 100%;\n}\n* {\n  @include font-roboto(200);\n  box-sizing: border-box;\n  outline: none;\n}\n*:focus {\n  outline: none;\n}\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n}\nbody {\n  min-height: 100%;\n  font-size: $font-lg;\n  \n  @media (max-width: $md){\n    font-size: $font-md;\n  }\n  @media(max-width:$sm){\n    font-size: $font-sm;\n  }\n}\n\nh1, h2, h3 ,h4, h5, h6 {\n  @include font-roboto(400);\n}\n\n.container {\n  width: 100%;\n  max-width: 1200px;\n  padding: 15px;\n  box-sizing: border-box;\n  margin: 0 auto;\n}\n\nhr.style-one {\n  width: 90%;\n  border: 0;\n  height: 1px;\n  background: #333;\n  background-image: linear-gradient(to right, #ccc, #333, #ccc);\n}\nhr.style-two {\n  width: 90%;\n  border: 0;\n  height: 1px;\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0));\n}\nhr.style-three {\n  width: 90%;\n  border: 0;\n  border-bottom: 1px dashed #ccc;\n  background: #999;\n}\n.error-color {\n  color: $color6;\n}\n\n\n\n/**  **/\n.profile-wrapper,\n.shifts-dashboard,\n.profile-components,\n.profile-page-content--show-tab {\n  -webkit-animation: fadein 1s; /* Safari, Chrome and Opera > 12.1 */\n  -moz-animation: fadein 1s; /* Firefox < 16 */\n  -ms-animation: fadein 1s; /* Internet Explorer */\n  -o-animation: fadein 1s; /* Opera < 12.1 */\n  animation: fadein 1s;\n  min-height: calc(100vh - 230px);\n}\n\n@keyframes fadein {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n/* Firefox < 16 */\n@-moz-keyframes fadein {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n/* Safari, Chrome and Opera > 12.1 */\n@-webkit-keyframes fadein {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n/* Internet Explorer */\n@-ms-keyframes fadein {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n/* Opera < 12.1 */\n@-o-keyframes fadein {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}","$color1: #e34634;\n$color2: #d02050;\n$color3: #46b1ff;\n$color4: #f5eee7;\n$color5: #baad9e;\n$color6: #aa004f;\n$color7: #bebebe;\n$color8: #d6d6d6;\n$color9: #f8f7f7;\n$color10: #202121;\n$color11: #848484;\n$color12: #aa004f;\n$color13: #37AA1E;\n$color14: #E4E5F1;\n$color15: #CB186B;\n$color16: #FCD3CA;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
